import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";
import modals from "webmodals/modals";
import RetailerPaymentMethodPrompt from "emun.retailer/retailer-payment-method-prompt";
import resolve from 'ioc/resolve'

export default class OrderEnterCreditcardController {
	constructor($uibModalInstance, options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.orderId = options.orderId;
		$ctrl.title = options.title || "Cards On File";
		$ctrl.prompt = new RetailerPaymentMethodPrompt();
	}

	$onInit() {
		const $ctrl = this;
		$ctrl.bus.send("QueryCarts.json?Id=" + $ctrl.orderId).then((res) => {
			if (res.data.results.length) {
				$ctrl.order = res.data.results[0];
				$ctrl.query = new AutoQuery({
					url: "QueryPaymentMethods/Wholesale/" + $ctrl.order.retailerId,
					fields:
					  "LastFour,LastFourNumbers,ExpiresOn,Expiration,Type,Token,Name,Address,Address2,City,State,Zip,Phone,EncryptedNumber,IsPrimary,TokenizationCode,RetailerId",
					pageSize: 24,
					sortBy: "Name",
					autoLoad: true,
					disableQueryString: true,
					filters: [{ groupBy: "Type" }, { groupBy: "State" }, { groupBy: "Zip" }],
					hideLeftNav: true,
					sortOptions: {
					  Name: 'Name: A to Z',
							  '-Name': 'Name: Z to A',
							  Type: 'Provider: A to Z',
							  '-Type': 'Provider: Z to A',
							  LastFour: 'Last Four: 1 to 9',
							  '-LastFour': 'Last Four: 9 to 1',
							  Expires: 'Expires: Soonest',
							  '-Expires': 'Expires: Latest',
							  Address: 'Address: A to Z',
							  '-Address': 'Address: Z to A'
					},
					scrub: (res) => {
						res.data.results = res.data.results.filter(
							(cc) => cc.tokenizationProvider !== "Aptean" 
						);
					},
				})


		
			}
		});
	}
	add() {
		const $ctrl = this;
		return $ctrl.prompt.add
		.apply(this.prompt, arguments)
		.then(() => $ctrl.query.load(true));
	}
	selectCC(card) {
		const $ctrl = this;
		let request = Object.assign({ cartId: $ctrl.orderId }, card);
		$ctrl.bus
		.send(
		  `ApplyPaymentMethod.json`,
		  request
		)
		.then(function (response) {
			resolve("$rootScope").$broadcast("creditcardChanged");

			$ctrl.bus.send("HostedPCI/GetGatewayToken", {
				VendorId: $ctrl.order.vendorId || $session.clientId,
				RetailerId: $ctrl.order.retailerId,
				Token: card.token,
				OrderNumber: $ctrl.orderId
			  }).then(function(gatewayResponse) {
				  if (gatewayResponse.data.status == "error") {
					modals
					.alert("There was an error saving the credit card for this order\r\n\r\nError: " + gatewayResponse.data.gatewayResponseStatus);
				  } else {
					$ctrl.$dismiss();
				}
			  });
		})
		.catch(errorToastFactory("cartUpdateFailed/ApplyPaymentMethod", request));
  

	}
}
